import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileExport} from "@fortawesome/free-solid-svg-icons/faFileExport";
import React from "react";

export default function FileExportIcon(props) {
    const { onClick} = props;

    return (
        <FontAwesomeIcon id={"fas fa-file-export"}
                         icon={faFileExport}  style={{fontSize: 30, cursor: 'pointer'}}
                         pull={"right"}
                         onClick={onClick}>

        </FontAwesomeIcon>
    )
}